import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zumos-categoria',
  templateUrl: './zumos-categoria.component.html',
  styleUrls: ['./zumos-categoria.component.css']
})
export class ZumosCategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
